import { render } from "./lyfileUpload.vue?vue&type=template&id=6f56f7d6&scoped=true"
import script from "./lyfileUpload.vue?vue&type=script&lang=js"
export * from "./lyfileUpload.vue?vue&type=script&lang=js"

import "./lyfileUpload.vue?vue&type=style&index=0&id=6f56f7d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f56f7d6"]])

export default __exports__